<template>
  <div class="container-fluid">
    
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 page-header margin-top-0px">
        <h5 class="font-size-15px text-align-center">New Report</h5>
      </div>
    </div>

    <div class="row padding-top-7px d-flex align-items-center">
      <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
        <button type="button" class="btn black-border custom-btn white-BG btn-sm cursor-pointer opacity-0" @click="performUserAction('clear_all')" :class="{'opacity-1' : selectedGroupObj !== -1 && groupCourseCohortList.length > 0}">
            Clear All
        </button>
        <button type="button" class="btn black-border custom-btn white-BG btn-sm cursor-pointer opacity-0" @click="performUserAction('select_all')" :class="{'opacity-1' : selectedGroupObj !== -1 && groupCourseCohortList.length > 0}">
            Select All
        </button>
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
        <span class="glyphicon glyphicon-option-vertical cursor-pointer font-size-20px" v-if="false"></span>
      </div>
    </div>
    
    <div class="row padding-top-15px">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        
        <select class="form-control input-sm Padding-right-0px" v-model="selectedGroupObjValue">
          <option value=-1 disabled>Select Group</option>
          <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj"> 
            {{ groupObj.GroupName + ' - ' + groupObj.CourseCount }} {{groupObj.CourseCount > 1 ? ' Courses' : ' Course'}} with {{ groupObj.ParticipantCount }} {{ groupObj.ParticipantCount > 1 ? ' Participants' : ' Participant'}} in {{groupObj.CohortCount}} {{groupObj.CohortCount > 1 ? ' Cohorts' : ' Cohort'}}
            </option>
        </select>

      </div>
    </div>
    <div class="row padding-top-15px" v-if="false">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-group margin-bottom-0px">
          <div class="icon-addon addon-lg">
            <input type="text" class="form-control input-sm border-rounded" autocomplete="off"/>
            <label class="glyphicon glyphicon-search"></label>
          </div>
        </div>
      </div>
    </div>
    <course-list v-for="currGCCObj in groupCourseCohortList"  :key="currGCCObj.GroupCourseMasterId" :currGccObj="currGCCObj" :selectedGroupObj="selectedGroupObjValue" :gccList="groupCourseCohortList"></course-list>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>
</template>

<script>
import CourseList from '@/components/new_report/CourseList'
import { dashboardService } from '@/server-util/dashboard-service.js'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { forEach } from 'lodash'
export default {
  props: ['groupList'],
  created: function () {},
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      selectedGroupObj: -1,
      groupCourseCohortList: []
    }
  },
  methods: {
    performUserAction: function (operationName) {
      if (this.selectedGroupObj !== -1 && this.groupCourseCohortList.length > 0) {
        switch (operationName) {
          case 'select_all':
            this.$store.state.selectedCohortIds = []
            forEach(this.groupCourseCohortList, (groupCourseObj) => {
              forEach(groupCourseObj.CohortProgressDataList, (cohortObj) => {
                this.$store.state.selectedCohortIds.push(cohortObj.CohortId)
              })
            })
            break
          case 'clear_all':
            this.$store.state.selectedCohortIds = []
            break
        }
        console.log('this.$store.state.selectedCohortIds' + this.$store.state.selectedCohortIds.length)
      }
    },
    getAssociatedGCC: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== null &&
        storeObj.state.access_token !== '' &&
        this.selectedGroupObj !== -1
      ) {
        _this.$store.state.isLoading = true
        dashboardService.getAllGroupStats(storeObj.state.access_token, this.selectedGroupObj.GroupId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.groupCourseCohortList = responseObj.data.GroupProgressDataList
              _this.$emit('groupProgressDataList', _this.groupCourseCohortList)
              _this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL Or Group is Not yet selected hence declined LOADING GROUP COURSE LIST')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'course-list': CourseList,
    'alert-box': AlertBox
  },
  name: 'LeftNavBar',
  computed: {
    getGroupList: {
      get: function () {
        return this.groupList
      }
    },
    selectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newValue) {
        this.selectedGroupObj = newValue
        this.groupCourseCohortList = []
        this.$store.state.selectedCohortIds = []
        this.$emit('updateCurrGroupObj', this.selectedGroupObj)
        this.getAssociatedGCC()
      }
    }
  }
}
</script>
<style scoped>
.opacity-0 {
  opacity: 0;
}
.opacity-1 {
  opacity: 1;
}
.background-gray {
  background-color: #ddd;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 7px 16px 6px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.float-Right {
  float: right !important;
}
.background-gray {
  background-color: #ddd;
}

.padding-top-15px {
  padding-top: 15px;
}
.padding-bottom-15px {
  padding-bottom: 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.black-border {
  border: 1px solid #aaa;
}
.border-top-0px {
  border-top: 0px;
}
.border-bottom-0px {
  border-bottom: 0px;
}
.custom-btn {
  padding: 5px 12px !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-top-7px {
  padding-top: 7px;
}
.font-size-15px {
  font-size: 15px;
}
.page-header {
  padding-bottom: 9px;
  margin: 40px 0 20px;
  border-bottom: 1px solid #eee;
}
.margin-top-0px {
  margin-top: 0px;
}
.text-align-center {
  text-align: center;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.font-size-20px {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/new_report/LeftNavBar.vue